import {updateCreateUpdateCategoryAction, updateCreateUpdateTagAction} from './actions'
import {NEW_CATEGORY} from './models'

function createUpdateCategoryActionUpdated() {
    var action

    return (state, dispatch) => {
        const nextAction = state.reference.createUpdateCategoryAction

        if (nextAction != action) {

            if (nextAction && nextAction.action != (action && action.action)) {
            	dispatch(updateCreateUpdateCategoryAction({uid: undefined, parentUid: undefined, label: undefined, iconId: undefined}))
            }
            action = nextAction
        }
    }
}

function createUpdateTagActionUpdated() {
    var action

    return (state, dispatch) => {
        const nextAction = state.reference.createUpdateTagAction

        if (nextAction != action) {

            if (nextAction && nextAction.action != (action && action.action)) {
                dispatch(updateCreateUpdateTagAction({uid: undefined, label: undefined, iconId: undefined}))
            }
            action = nextAction
        }
    }
}

export default [createUpdateCategoryActionUpdated(), createUpdateTagActionUpdated()]


// WEBPACK FOOTER //
// ./lib/reference/actors.js